import React from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import getCookieConsent from '../../services/CookieConsent';
const EventTracker = ({ eventNumber }) => {
  const affiliateTracking = getCookieConsent();
  const location = useLocation();
  if (!affiliateTracking?.performance) return null;
  if (typeof document === 'undefined' || !document) return null;

  const orgId = '4cmatchzkg5l7ixgqsjwpsthffa9cmrv';
  // casting to string
  eventNumber = '' + eventNumber;
  // url parameters
  let eventId;
  let udid;
  let msxt;

  // Detection of parameters in url

  const msParamReader = (currentUrl, parameterName, valuePrefix) => {
    if (!currentUrl) {
      currentUrl = '';
    }
    let indexStart = currentUrl.indexOf('' + parameterName + '=');
    if (indexStart == -1) {
      indexStart = currentUrl.indexOf('' + valuePrefix);
    }
    let result = indexStart != -1 ? currentUrl.substring(indexStart) : '';
    let indexEnd = result.indexOf('&');
    if (indexEnd != -1) {
      result = result.substring(0, indexEnd);
    }
    result = result.replace('' + parameterName + '=', '');
    result = result.replace('' + valuePrefix + ':', '');
    return result;
  };

  if (!msxt && document.location && document.location.href) {
    msxt = msParamReader('' + document.location.href, 'msxt', 'msxt');
  }

  if (!msxt && document.referrer) {
    msxt = msParamReader('' + document.referrer, 'msxt', 'msxt');
  }

  if (!msxt && location.search) {
    msxt = msParamReader('' + location.search, 'msxt', 'msxt');
  }

  if (!udid && document.location && document.location.href) {
    udid = msParamReader('' + document.location.href, 'udid', 'msck');
  }

  if (!udid && document.referrer) {
    udid = msParamReader('' + document.referrer, 'udid', 'msck');
  }

  if (document.location && document.location.href) {
    let newEventId = msParamReader(
      '' + document.location.href,
      'eventid',
      'msev',
    );
    if (newEventId) eventId = newEventId;
  }

  if (!eventId && document.referrer) {
    let newEventId = msParamReader('' + document.referrer, 'eventid', 'msev');
    if (newEventId) eventId = newEventId;
  }

  let url =
    '/api/affiliate/?orgid=' +
    encodeURIComponent(orgId) +
    '&ms_event_num=' +
    encodeURIComponent(eventNumber);
  if (eventId) {
    url += '&id=' + encodeURIComponent(eventId);
  }
  if (udid) {
    url += '&udid=' + encodeURIComponent(udid);
  }
  if (msxt) {
    url += '&msxt=msxt:' + encodeURIComponent(msxt);
  }
  url += '&burst=' + new Date().getTime();

  return <img style={{ display: 'none' }} src={url} />;
};

export default EventTracker;

export const HomepageEvent = 1;
export const OrderPageEvent = 2;
export const BasketEvent = 3;
export const PaymentEvent = 4;
export const OrderSuccessEvent = 5;
